<template>
  <div class="pa-4">
    <div class="d-flex align-center mb-4">
      <h1>DatePicker封装📦</h1>
    </div>
    <p>封装组件DateSinglePicker 封装v-date-picker可以切换语言 TODO v-model 双向绑定</p>
    <div class="d-flex">
      <DateSinglePicker 
        v-model="date"
        @changeDate="changeDate"
      />
      <v-select
        v-model="lang"
        hide-details
        :items="['zhHans', 'en', 'ja']"
        style="flex: initial;"
        class="ml-2"
        dense
        small
        outlined
        clearable
        @change="$i18n.locale = lang"
      />
    </div>
    <div>
      date: {{ date }}
    </div>

    <p>组件v-text-field 类原生输入简单可靠</p>
    <v-text-field
      v-model="date1"
      label="date1"
      type="date"
      class="mt-2"
      dense
      small
      outlined
      hide-details
      clearable
      style="max-width: fit-content;min-width: 180px;"
    />
    <div>
      date1: {{ date1 }}
    </div>

    <p>原生input</p>
    <input
      v-model="date2"
      type="date"
      style="
        /* max-width: fit-content; */
        /* min-width: 200px; */
        flex: initial;
        border: 1px solid rgba(0, 0, 0, 0.42);
        border-radius: 4px;
        padding: 0 12px;
        line-height: 36px;"
    >
    <div>
      date2: {{ date2 }}
    </div>
    <hr class="mb-4">

    <p>封装组件DateRangePicker 封装v-date-picker</p>
    <p>
      date3: {{ date3 }}
    </p>
    <DateRangePicker
      v-model="date3"
      @change="changeDate3"
    />
  </div>
</template>

<script>
import DateSinglePicker from './DateSinglePicker.vue'
import DateRangePicker from './DateRangePicker.vue'

export default {
  components: {
    DateSinglePicker,
    DateRangePicker,
  },
  data: () => ({
    lang: '',
    date: '',
    date1: '',
    date2: '',
    date3: [],
  }),
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.lang = this.$i18n.locale;
      this.date1 = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
      this.date2 = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
    })
  },
  methods: {
    handleChange() {
      console.log(this.date, 'change');
    },
    handleInput(e) {
      console.log(e, this.date, 'handleInput');
    },
    changeDate(e) {
      console.log(e, this.date, 'changeDate');
    },
    changeDate3(dates) {
      console.log(dates, this.date3, 'changeDate3');
    }
  },
}
</script>

<style scoped>

</style>